import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Document from '../../entities/extranet/document'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface DocumentState extends ListState<Document>{
    editModel: Document;
    downloading: boolean;
    uploading: boolean;
}
class DocumentModule extends ListModule<DocumentState,any,Document>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Document>(),
        loading:false,
        downloading:false,
        uploading:false,
        editModel: new Document(),
        activeList: new Array<Document>(),
        path: 'documents'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getAll(context: ActionContext<DocumentState, any>, payload: any) {
            let items = context.state.list.filter(item => { return item.category_id == payload.data.category });
            if (items.length > 0) return;

            context.state.loading = true;
            let reponse = await Ajax.get('/api/documents', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.list.push(...reponse.data.result);
            context.state.totalCount = context.state.list.length;            
        },
        async create(context: ActionContext<DocumentState, any>, payload: any) {
            context.state.uploading = true;
            let response = await Ajax.post('/api/documents', payload.data).catch(e => {
                context.state.uploading = false;
                return Promise.reject(e);
            });
            context.state.uploading = false;
            if (response.data.result)
                context.state.list.push(response.data.result);
            return response.data.result;
        },
        async delete(context: ActionContext<DocumentState, any>, payload: any) {
            context.state.loading = true;
            let id = payload.data.id;
            await Ajax.delete('/api/' + (context.state as any).path + '/' + id).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.list = context.state.list.filter((item: any) => {
                return item.id !== id;
            });
        },
        async upload(context: ActionContext<DocumentState, any>, payload: any) {
            context.state.uploading = true;
            let response = await Ajax.post('/api/documents/upload',
                payload.data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).catch(e => {
                context.state.uploading = false;
                return Promise.reject(e);
            });
                        
            if (response.data.result.id != undefined)
                context.state.list.push(response.data.result);

            context.state.uploading = false;
            return true;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const documentModule=new DocumentModule();
export default documentModule;
